import { sizes } from "../../../constants/sizes";
import { ReactComponent as RafterIcon } from "../../../svgs/rafters.svg";
import { ReactComponent as CableIcon } from "../../../svgs/cable.svg";
import { ReactComponent as BushingIcon } from "../../../svgs/bushing.svg";
import { useRef } from "react";

import { useReactToPrint } from "react-to-print";

const Rafters = ({ project, handleEditProject }) => {
  const {
    eaves,
    kitName,
    size,
    cableSize,
    cableAmount,
    mainBushingSize,
    mainBushingQuantity,
    secondBushingSize,
    secondBushingQuantity,
    thirdBushingSize,
    rafterSize,
    rafterNotes,
    bushingsPerRafter,
  } = project;

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className="sheet-comp-container">
      <div className="sheet-input">
        <div id="sheet-print-button" onClick={handlePrint}>
          print
        </div>
        <div className="sheet-input-section">
          <RafterIcon />
          <div className="sheet-input-item">
            <label>Rafter Size</label>
            <select
              className="form-control"
              name="rafterSize"
              onChange={(e) => handleEditProject(e)}
              defaultValue={rafterSize}
            >
              <option>2 x 12</option>
              <option>2 x 10</option>
              <option>LVL 1 1/2" x 11 3/4"</option>
              <option>LVL 1 3/4" x 11 7/8"</option>
              <option>LVL 1 3/4" x 14"</option>
            </select>
          </div>
        </div>
        <div className="sheet-input-section">
          <CableIcon />
          <div className="sheet-input-item">
            <label>Cable Size</label>
            <select
              className="form-control"
              name="cableSize"
              onChange={(e) => handleEditProject(e)}
              defaultValue={cableSize}
            >
              <option>1 / 4"</option>
              <option>5 / 16"</option>
              <option>3 / 8"</option>
            </select>
          </div>
          <div className="sheet-input-item">
            <label>Cable Amount</label>
            <input
              className="form-control"
              name="cableAmount"
              onChange={(e) => handleEditProject(e)}
              defaultValue={cableAmount}
            />
          </div>
        </div>
        <div className="sheet-input-section">
          <BushingIcon />
          <div className="sheet-input-item">
            <label>Bushings Per Rafter</label>
            <input
              className="form-control"
              name="bushingsPerRafter"
              onChange={(e) => handleEditProject(e)}
              defaultValue={bushingsPerRafter}
            />
          </div>
        </div>
        <div className="sheet-input-section">
          <BushingIcon />
          <div className="sheet-input-item">
            <label>Main Bushing Size</label>
            <select
              className="form-control"
              name="mainBushingSize"
              onChange={(e) => handleEditProject(e)}
              defaultValue={mainBushingSize}
            >
              <option>S (1/2)</option>
              <option>L (3/4)</option>
              <option>XL (1 3/8)</option>
            </select>
          </div>
          <div className="sheet-input-item">
            <label>Main Bushing Quantity</label>
            <input
              className="form-control"
              name="mainBushingQuantity"
              onChange={(e) => handleEditProject(e)}
              defaultValue={mainBushingQuantity}
            />
          </div>
        </div>
        <div className="sheet-input-section">
          <BushingIcon />
          <div className="sheet-input-item">
            <label>Second Bushing Size</label>
            <select
              className="form-control"
              name="secondBushingSize"
              onChange={(e) => handleEditProject(e)}
              defaultValue={secondBushingSize}
            >
              <option>S (1/2)</option>
              <option>L (3/4)</option>
              <option>XL (1 3/8)</option>
            </select>
          </div>
          <div className="sheet-input-item">
            <label>Second Bushing Quantity</label>
            <input
              className="form-control"
              name="secondBushingQuantity"
              onChange={(e) => handleEditProject(e)}
              defaultValue={secondBushingQuantity}
            />
          </div>
        </div>
        <div className="sheet-input-section">
          <BushingIcon />
          <div className="sheet-input-item">
            <label>Third Bushing Size</label>
            <select
              className="form-control"
              name="thirdBushingSize"
              onChange={(e) => handleEditProject(e)}
              defaultValue={thirdBushingSize}
            >
              <option>S (1/2)</option>
              <option>L (3/4)</option>
              <option>XL (1 3/8)</option>
            </select>
          </div>
        </div>
        <br />
        <div className="sheet-input-item">
          <label>Notes</label>
          <textarea
            className="form-control"
            name="rafterNotes"
            onChange={(e) => handleEditProject(e)}
            defaultValue={rafterNotes}
          />
        </div>
      </div>
      <div className="sheet-output" ref={componentRef}>
        <div className="sheet-title">
          <div className="sheet-icon-title">
            <RafterIcon />
            <div>Rafters</div>
          </div>
          <div>
            {kitName} - {sizes[size]}
          </div>
        </div>

        <div className="sheet-body">
          <div className="sheet-column">
            <div className="sheet-item">
              <div>Rafter Size</div>
              <div>{rafterSize}</div>
            </div>
            <div className="sheet-item">
              <div>Rafter Amount</div>
              <div>{size * 2}</div>
            </div>
            <div className="sheet-item">
              <div>Eaves</div>
              <div>{eaves}"</div>
            </div>
          </div>
          <div className="sheet-column">
            <div className="sheet-table--sm">
              <div className="sheet-table-title">
                <div>Cables</div>
                <CableIcon />
              </div>
              <div className="sheet-table-body">
                <div className="sheet-table-col">
                  <div>Size</div>
                  <div>Amount</div>
                </div>
                <div className="sheet-table-col">
                  <div>{cableSize}</div>
                  <div>{cableAmount}</div>
                </div>
              </div>
            </div>
            <div className="sheet-table--sm">
              <div className="sheet-table-title">
                <div>Bushings</div>
                <BushingIcon />
              </div>
              <div className="sheet-table-body">
                <div className="sheet-table-col --bushings-table">
                  <div>size</div>
                  <div>{mainBushingSize}</div>
                  <div>{secondBushingSize}</div>
                  <div>{thirdBushingSize}</div>
                </div>
                <div className="sheet-table-col --bushings-table">
                  <div>quantity</div>
                  <div>{mainBushingQuantity}</div>
                  <div>{secondBushingQuantity}</div>
                  <div>
                    {size * 2 * bushingsPerRafter -
                      mainBushingQuantity -
                      secondBushingQuantity}
                  </div>
                </div>
                <div className="sheet-table-col --bushings-table">
                  <div>per rafter</div>
                  <div>{bushingsPerRafter}</div>
                  <div>{bushingsPerRafter}</div>
                  <div>{bushingsPerRafter}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="sheet-body">
          <div className="sheet-table--sm">
            <div className="sheet-table-body">
              <div className="sheet-table-col">
                <div>all holes drilled</div>
                <div>rafter tips oiled</div>
                <div>cardboard covering rafter tips</div>
                <div>photo taken</div>
              </div>
              <div className="sheet-table-col">
                <div>
                  <span className="sheet-checkbox"></span>
                </div>
                <div>
                  <span className="sheet-checkbox"></span>
                </div>
                <div>
                  <span className="sheet-checkbox"></span>
                </div>
                <div>
                  <span className="sheet-checkbox"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sheet-notes">
          <div className="sheet-notes-title">notes</div>
          <div className="sheet-notes-body">{rafterNotes}</div>
        </div>
      </div>
    </div>
  );
};

export default Rafters;
